import { AlertTriangle, Mail, Phone, ShieldAlert } from "lucide-react";
import { useSelector } from "react-redux";
import { getText } from "../i18n";
import { useEffect } from "react";
import {socket} from '../axios/api'
import { useNavigate } from "react-router-dom";

const ExpiredLicense = () => {

    const navigate = useNavigate();
    const user =  useSelector((state) => state.user.user)
    useEffect(() => {
        socket.on("license_created", (data) => {
            if(data.empresa_id === user.empresa_id) {
                navigate(`/dashboard`)
            }
        });
    }, []);

  const currentLang = useSelector((state) => state.language.currentLanguage);
  const t = getText(currentLang, "auth");
  const common = getText(currentLang, "common");

  return (
    <div className="login-shell-expired">
      {/* Visual da esquerda igual ao Login */}
      <div className="login-visual-expired">
        <div className="brand-orb-expired">F</div>
        <h1>Facturize</h1>
        <p>A gestão do seu negócio não pode parar.</p>
        <div className="login-metrics-expired">
          <span>Acesso Suspenso</span>
          <span>Renovação Pendente</span>
        </div>
      </div>

      {/* Painel da direita */}
      <main className="login-panel-expired">
        <div className="login-card-expired">
          <div className="login-card-head-expired">
            <div>
              <span className="eyebrow-expired">Aviso do Sistema</span>
              <h2>Licença Expirada</h2>
              <p>O acesso ao Facturize foi limitado.</p>
            </div>
            <ShieldAlert size={28} style={{ color: "#d97706" }} />
          </div>

          <div className="alert-box-expired">
            <AlertTriangle size={40} />
            <p>Sua licença expirou e não está mais ativa. Para continuar utilizando todos os recursos do Facturize, por favor, entre em contato com nossa equipe de suporte para efetuar a renovação.</p>
          </div>

          <div className="contact-info-expired">
            <div className="contact-item-expired">
              <Mail size={18} />
              <span>suporte@facturize.net</span>
            </div>
            <div className="contact-item-expired">
              <Phone size={18} />
              <span>+244 946 369 451</span>
            </div>
          </div>
         
          <button 
            type="button" 
            className="login-submit-expired" 
            onClick={() => window.location.href = 'mailto:suporte@facturize.net'}
          >
            Solicitar Renovação
          </button>
          <button 
            type="button" 
            className="login-submit-expired mt-2 bg-danger" 
            onClick={() => navigate("/auth/logout")}
          >
            Terminar Sessão
          </button>
        </div>
      </main>

      <style>{`
        .login-shell-expired {
          min-height: 100vh;
          display: grid;
          grid-template-columns: minmax(360px, 0.95fr) minmax(360px, 1.05fr);
          background: #f9fafb;
          color: #111827;
        }
        .login-visual-expired {
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 56px;
          background: linear-gradient(145deg, rgba(15, 139, 141, 0.88), rgba(16, 32, 39, 0.96));
          color: #fff;
        }
        .brand-orb-expired {
          width: 72px; height: 72px; display: flex; align-items: center; justify-content: center;
          border-radius: 22px; background: #fff; color: #0f8b8d; font-size: 34px; font-weight: 900;
        }
        .login-visual-expired h1 { margin: 28px 0 8px; font-size: 60px; font-weight: 900; }
        .login-metrics-expired { display: flex; gap: 10px; margin-top: 30px; }
        .login-metrics-expired span {
          padding: 8px 14px; border: 1px solid rgba(255,255,255,0.2);
          border-radius: 999px; font-size: 12px; font-weight: 800;
        }
        .login-panel-expired { display: flex; align-items: center; justify-content: center; padding: 32px; }
        .login-card-expired { width: 100%; max-width: 460px; padding: 34px; border-radius: 24px; background: #fff; box-shadow: 0 10px 25px rgba(0,0,0,0.1); }
        .login-card-head-expired { display: flex; justify-content: space-between; margin-bottom: 28px; }
        .eyebrow-expired { color: #6b7280; font-size: 11px; font-weight: 900; text-transform: uppercase; }
        .alert-box-expired { padding: 20px; background: #fffbeb; border-radius: 16px; color: #d97706; text-align: center; display: flex; flex-direction: column; align-items: center; gap: 10px; border: 1px solid #fef3c7; }
        .alert-box-expired p { color: #d97706 !important; font-size: 14px; margin: 0; }
        .contact-info-expired { margin: 24px 0; display: flex; flex-direction: column; gap: 12px; }
        .contact-item-expired { display: flex; align-items: center; gap: 12px; padding: 12px; background: #f3f4f6; border-radius: 12px; font-weight: 600; }
        .login-submit-expired {
          width: 100%; min-height: 52px; border: 0; border-radius: 16px;
          color: #fff; background: #0f8b8d; font-weight: 900; cursor: pointer;
        }
        @media (max-width: 900px) {
          .login-shell-expired { grid-template-columns: 1fr; }
          .login-visual-expired { min-height: 250px; }
        }
      `}</style>
    </div>
  );
};

export default ExpiredLicense;